import type { Mission } from '../missions.ts'

export const usmint: Mission = {
  id: "usmint",
  name: "United States Mint",
  short: "U.S. Mint",
  call: "Mint",
  kind: "subagency",
  parent: "treasury",
  url: "https://www.usmint.gov/",
  established: 1792,
  palette: {
    primary: "#005278",
    secondary: "#369dd5",
    accent: "#ffc46f",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Mint.svg",
  },
  motif: "anvil",
  mission: {
    text: "The mission of the U.S. Mint is to serve the American people by manufacturing and distributing circulating, precious metal and collectible coins and national medals, and providing security over assets entrusted to us.",
    url: "https://www.usmint.gov/about",
  },
  fact: {
    text: "The Mint is the nation’s sole manufacturer of legal tender coinage and is responsible for producing circulating coinage for the nation to conduct its trade and commerce.",
    url: "https://www.usmint.gov/about",
  },
  seal: {
    file: "public/seals/usmint.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Mint.svg",
  },
  identifier: {
    about: "https://www.usmint.gov/about",
    accessibility: "https://www.usmint.gov/resources/accessibility",
    foia: "https://www.usmint.gov/resources/foia",
    noFear: "https://home.treasury.gov/footer/no-fear-act",
    oig: "https://oig.treasury.gov/",
    performance: "https://www.usmint.gov/about/reports",
    privacy: "https://www.usmint.gov/resources/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/usmint-philadelphia.jpg",
        small: "/media/usmint-philadelphia-sm.jpg",
        alt: "The granite facade of the Philadelphia Mint, lettered United States Mint, Department of the Treasury, between two carved eagles above the sidewalk.",
        title: "United States Mint at Philadelphia, Pennsylvania, February 29, 2024",
        creator: "Ajay Suresh",
        source: "https://commons.wikimedia.org/wiki/File:United_States_Mint_(53572938965).jpg",
        license: "CC BY 2.0",
      },
    ],
  },
}
